import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../../services/api";

export const fetchLicenseRequests = createAsyncThunk(
  "billing/fetch_license_requests",
  async (body) => {
    let query = "";
    if (body.page) {
      query += `&page=${body.page}`;
    }
    if (body.page_size) {
      query += `&page_size=${body.page_size}`;
    }
    const apiFetch = await apiRequest.get(`v1/billing/?${query}`, {
      headers: { organization: body.userOrganization.org_id },
    });
    return apiFetch.data;
  }
);

export const createLicenseRequest = createAsyncThunk(
  "billing/create_license_requests",
  async (body) => {
    const apiPost = await apiRequest.post(
      `v1/billing/`,
      {
        license_type: body.license_type,
        license_count: body.license_count,
      },
      { headers: { organization: body.userOrganization.org_id } }
    );
    return apiPost;
  }
);
